import MataPelajaran from '../../../views/Kurikulum/MataPelajaran/MataPelajaran.view';

export default MataPelajaran;